import * as React from "react";
import PasswordResetForm from "./PasswordResetForm";
import { INVITED_APP_BASE_URL } from "../../common";
import Logo from "../../assets/invited-logo.svg";
import { NavLink, useNavigate } from "react-router";
import { Button } from "@/components/ui/button";

export default () => {
  const nav = useNavigate();
  const [completed, setCompleted] = React.useState<boolean>(false);

  return (
    <div className="bg-[#f9f9f9] min-h-screen flex flex-col items-center">
      <div className="flex items-center justify-between w-full h-[100] border-b-1 border-b-[#dddddd] px-12">
        <a href={INVITED_APP_BASE_URL}>
          <Logo
            className="h-[28]"
          />
        </a>
        <NavLink className="text-xl font-semibold text-[#333]" to="/sign-up">
          Sign Up
        </NavLink>
      </div>
      <div className="pt-16">
        {completed ? (
          <div className="flex flex-col justify-center">
            <div className="text-xl">Your password has been updated.</div>
            <Button
              className="mt-4"
              onClick={() => {
                nav("/login");
              }}
            >
              Return To Login
            </Button>
          </div>
        ) : (
          <PasswordResetForm
            success={() => {
              setCompleted(true);
            }}
          />
        )}
      </div>
    </div>
  );
};
